import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import HeaderNav from "@/components/HeaderNav";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import FlyFishing from "@/pages/FlyFishing";
import Checklists from "@/pages/Checklists";
import Journal from "@/pages/Journal";
import JournalArticle from "@/pages/JournalArticle";
import IdentifyFly from "@/pages/IdentifyFly";
import Gear from "@/pages/Gear";

function ScrollReset() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.__lenis?.scrollTo(0, { immediate: true });
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

export default function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        window.__lenis = lenis;
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);
        return () => {
            cancelAnimationFrame(raf);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="grain bg-[#0B1320] min-h-screen text-slate-100">
            <BrowserRouter>
                <ScrollReset />
                <HeaderNav />
                <main>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/fly-fishing" element={<FlyFishing />} />
                        <Route path="/checklists" element={<Checklists />} />
                        <Route path="/journal" element={<Journal />} />
                        <Route path="/journal/:slug" element={<JournalArticle />} />
                        <Route path="/identify-my-fly" element={<IdentifyFly />} />
                        <Route path="/gear" element={<Gear />} />
                    </Routes>
                </main>
                <Footer />
                <Toaster
                    theme="dark"
                    position="bottom-right"
                    toastOptions={{
                        style: {
                            background: "#111C2E",
                            border: "1px solid rgba(20,184,166,0.35)",
                            color: "#F1F5F9",
                        },
                    }}
                />
            </BrowserRouter>
        </div>
    );
}
